import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import {AutocompleteArrayInput, FormWithRedirect, ReferenceArrayInput, SelectInput, TextInput} from "react-admin";
import { CustomToolbar } from "../components/CustomToolbar";
import { ReferenceInputSubject } from "../components/reference-inputs/ReferenceInputSubject";
import { FormProps } from "../shared/types";
import { initInput } from "../shared/utils";
import {ReferenceArrayInputSubject} from "../components/reference-inputs/ReferenceArrayInputSubject";
import React from "react";

// Final Form re-registers the field when the defaultValue reference changes.
const emptyUsers: number[] = [];

export const SiteForm = (props: FormProps) => {
  return (
    <FormWithRedirect
      {...props}
      render={(formProps) => (
        <Card>
          <form>
            <CardContent>
              <Grid
                container
                justifyContent="flex-start"
                direction={"row"}
                spacing={2}
              >
                  <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom>
                      Info principali
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <TextInput
                      {...initInput(
                        "business_name",
                        props.fieldOptions,
                        props.canEdit
                      )}
                    />
                  </Grid>
                  <Grid item xs={6}>
                      <SelectInput
                          choices={props.fieldOptions.site_type.choices}
                          {...initInput(
                              "site_type",
                              props.fieldOptions,
                              props.canEdit,
                              "array"
                          )}
                      />
                  </Grid>
                  <Grid item xs={6}>
                    <ReferenceInputSubject
                      {...initInput(
                        "default_store_id",
                        props.fieldOptions,
                        props.canEdit
                      )}
                      filter={{ type: "store" }}
                      fullWidth={true}
                    />
                  </Grid>
                    <Grid item xs={6}>
                        <ReferenceArrayInputSubject source={"carriers"} fullWidth/>
                  </Grid>
                  <Grid item xs={6}>
                    <ReferenceArrayInput
                      {...initInput("users", props.fieldOptions, props.canEdit)}
                      reference="autocomplete/user"
                      label="Utenti"
                      defaultValue={emptyUsers}
                      variant="outlined"
                      fullWidth
                    >
                      <AutocompleteArrayInput optionText="label" />
                    </ReferenceArrayInput>
                  </Grid>

                </Grid>
            </CardContent>
            <CustomToolbar
              canDelete={props.canDelete}
              canEdit={props.canEdit}
              resource={props.resource}
              pristine={formProps.pristine}
              record={formProps.record}
              mutationMode={props.mutationMode}
              invalid={formProps.invalid}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
              basePath={props.basePath}
            />
          </form>
        </Card>
      )}
    />
  );
};
